import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@deepguide-ai/ui/table'

export function AuditorInlineEmptyState({ message }: { message: string }) {
  return (
    <div className='border-border bg-surface-subtle text-text-subtle rounded-sm border border-dashed px-3 py-2.5 text-[12px]'>
      {message}
    </div>
  )
}

export function AuditorSectionListState(props: {
  isLoading: boolean
  loadingMessage: string
  isEmpty: boolean
  emptyMessage: string
  children: ReactNode
}) {
  if (props.isLoading) {
    return (
      <div className='rounded-sm border border-border bg-card p-8 text-[13px] text-text-subtle'>
        {props.loadingMessage}
      </div>
    )
  }

  if (props.isEmpty) {
    return (
      <div className='rounded-sm border border-dashed border-border-muted p-8 text-center text-[13px] text-text-subtle'>
        {props.emptyMessage}
      </div>
    )
  }

  return <>{props.children}</>
}

export function ActivityTable({
  items,
  className,
}: {
  items: Array<{ id: string; eventType?: string; title?: string; actorLabel?: string; targetLabel?: string; category?: string; createdAt: string | Date }>
  className?: string
}) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-sm border border-border bg-card',
        className,
      )}
    >
      <Table>
        <TableHeader>
          <TableRow className='h-[40px] border-b border-border bg-surface-subtle hover:bg-surface-subtle'>
            <TableHead className='px-4 py-2.5 font-body'>Event</TableHead>
            <TableHead className='px-4 py-2.5 font-body'>User</TableHead>
            <TableHead className='px-4 py-2.5 font-body'>Target</TableHead>
            <TableHead className='px-4 py-2.5 font-body'>Category</TableHead>
            <TableHead className='px-4 py-2.5 font-body'>Timestamp</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
        {items.map((item) => (
          <TableRow
            key={item.id}
            className='border-b border-border bg-card transition-colors hover:bg-surface-subtle'
          >
            <TableCell className='px-4 py-2.5 font-body'>
              {item.title ?? item.eventType}
            </TableCell>
            <TableCell className='px-4 py-2.5 font-body'>
              {item.actorLabel || '—'}
            </TableCell>
            <TableCell className='px-4 py-2.5 font-body'>
              {item.targetLabel || '—'}
            </TableCell>
            <TableCell className='px-4 py-2.5 font-body capitalize'>
              {item.category || '—'}
            </TableCell>
            <TableCell className='px-4 py-2.5 font-body whitespace-nowrap'>
              {new Date(item.createdAt).toLocaleString()}
            </TableCell>
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </div>
  )
}
